<template>
  <div class="dropdown" v-bind:class="{show: enabled}">
    <button class="btn btn-secondary dropdown-toggle" type="button" v-on:click.stop="toggle()" id="dropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
      {{text}}
    </button>
    <div class="dropdown-menu" aria-labelledby="dropdownMenuLink" v-click-outside="outsideClick">
      <slot name="dropdown-menu">
      </slot>
    </div>
  </div>
</template>

<script>
import {EventBus} from 'services/eventBus'

export default {
  name: 'dropdown-button',
  props: ['text', 'group'],
  created () {
    EventBus.$on(this.eventGroup, dropdown => {
      this.disabledByGroup(dropdown)
    })
  },
  data () {
    return {
      enabled: false
    }
  },
  methods: {
    toggle () {
      this.enabled = !this.enabled
      EventBus.$emit(this.eventGroup, this)
    },
    disabledByGroup (dropdown) {
      if (dropdown._uid !== this._uid && this.enabled) {
        this.enabled = false
      }
    },
    outsideClick (event) {
      this.enabled = false
    }
  },
  computed: {
    eventGroup: function () {
      return 'toggle-dropdown-button-' + this.group
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/DropdownButton.vue